import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class Units extends AbstractController {
    protected controllerName = 'Units';
}
